import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {motion} from "framer-motion"

import Styles from './Pricing.scss'
import NonPublicAccess from "./NonPublicAccess";
import Swal from "sweetalert2";
import PricingPanel from "../../admin/components/dashboard/PricingPanel";
import PricingPlans from '../../admin/components/dashboard/PricingPlans';

const Pricing = (props) => {

    const [type, setType] = useState('pro')
    const [backgroundColorTheme, setBackgroundColorTheme] =  useState(" #454756");
    const [ baseColorTheme, setBaseColorTheme] = useState(" #FFFFFF");

    const togglePricingVariants = {
        open: { top: "0px", "marginTop": "0px", opacity: 1, display: "block"},
        closed: { top: "-1800px", "marginTop": "60px", opacity: 0, display: "none" }
    }

    useEffect(()=>{
        (props.uiTheme && props.uiTheme==="light")?setBackgroundColorTheme(" #FFFFFF"):setBackgroundColorTheme(" #454756");
        (props.uiTheme && props.uiTheme==="light")?setBaseColorTheme(" #454756"):setBaseColorTheme(" #FFFFFF");
    },[])

    useEffect(()=>{
        (props.uiTheme && props.uiTheme==="light")?setBackgroundColorTheme(" #FFFFFF"):setBackgroundColorTheme(" #454756");
        (props.uiTheme && props.uiTheme==="light")?setBaseColorTheme(" #454756"):setBaseColorTheme(" #FFFFFF");
    }, [type, props.uiTheme])

    useEffect(()=>{
        //console.log(props.showPricing)
    }, [props.showPricing])

    const handleSubscription = (ev)=>{

        //(ev!=='collective')?window.location.href = '/subscription/'+ev:window.location.href = '/partenaria';
        Swal.fire(
            {title: '<p style="color:' + baseColorTheme + ';">Formulaire</p>',
                html: `<div style="color:` + baseColorTheme + `;"><h1><i class="bi bi-emoji-frown"></i></h1><p>Désolé. Cette action n'est pas encore accessible avec votre compte !</p>
                            <p>Merci de contacter <a href="mailto:info@urbahearth.fr">Les gestionnaires</a>  pour plus d'informations : </p></div>`,
                background: backgroundColorTheme,
                width: '19rem',
                confirmButtonText: 'Fermer',
                backdrop: true,
            })
    }

    return (
       <motion.div
           animate={ props.showPricing?"open":"closed"}
           ransition={{ type: "easeInOut", duration: 1.5 }}
           variants={togglePricingVariants}
            className={'pricingMain'}
       >
             <PricingPlans />
       </motion.div>
    );
};

const mapStateToProps = state => {
    return {
        showPricing : state.LeftPanelReducer.showPricing,
        uiTheme : state.AppReducer.ui_theme,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        setShowPricing : (e)=>dispatch({type: 'SET_SHOW_PRICING', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(Pricing);
